import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-end justify-center overflow-hidden grain-overlay">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/6dfd3498bc455a51398a41f149dd0165.jpg"
          alt="Luxury wedding ceremony at Red Door Ranch venue in Joshua TX"
          className="w-full h-full object-cover object-center scale-105"
          style={{ animation: 'heroZoom 16s ease-out forwards' }}
        />
        {/* Cinematic multi-layer overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-rdr-dark via-rdr-dark/25 to-rdr-dark/15" />
        <div className="absolute inset-0 bg-gradient-to-r from-rdr-dark/40 via-transparent to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-b from-rdr-dark/30 to-transparent" />
      </div>

      {/* Content — bottom-anchored for cinematic feel */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pb-24 lg:pb-32 pt-36">
        <div className="max-w-4xl">
          {/* Eyebrow */}
          <div className="hero-eyebrow flex items-center gap-4 mb-8">
            <span className="block w-12 h-px bg-rdr-gold" />
            <p className="text-rdr-gold text-xs tracking-[0.35em] uppercase font-sans font-medium">
              Joshua, TX — Premier Luxury Wedding Venue
            </p>
          </div>

          {/* Main Headline */}
          <h1 className="hero-headline font-serif text-white text-5xl lg:text-6xl xl:text-[4.5rem] leading-[1.04] mb-8 max-w-3xl">
            Where Unforgettable Events Become{' '}
            <em className="italic text-rdr-gold">Timeless</em>{' '}
            Experiences
          </h1>

          {/* Subheadline */}
          <p className="hero-sub text-white/70 font-sans text-lg lg:text-xl max-w-lg mb-12 leading-relaxed">
            A 20-acre hilltop estate crafted for weddings, private events, and
            gatherings that deserve something truly extraordinary.
          </p>

          {/* Dual CTA — bold, premium */}
          <div className="hero-cta flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link
              to="/location#contact"
              className="inline-flex items-center gap-3 bg-rdr-gold text-white font-sans text-xs tracking-[0.25em] uppercase px-10 py-4 hover:bg-rdr-gold-light transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Book a Private Tour
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm" />
              </div>
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/30 text-white font-sans text-xs tracking-[0.25em] uppercase px-10 py-4 hover:bg-white/20 hover:border-white/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Check Availability
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-check-line text-sm" />
              </div>
            </Link>
          </div>
        </div>

        {/* Stats strip — below content */}
        <div className="hero-cta mt-16 lg:mt-20 pt-8 border-t border-white/10 flex flex-wrap items-center gap-8 lg:gap-14">
          {[
            { value: '20', label: 'Private Acres' },
            { value: '300', label: 'Guest Capacity' },
            { value: '6,000+', label: 'Sq Ft Indoor' },
            { value: '1', label: 'Exclusive Event/Day' },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-4">
              <span className="font-serif text-white text-3xl font-medium leading-none">{stat.value}</span>
              <div className="w-px h-8 bg-white/15" />
              <span className="text-white/45 font-sans text-[11px] tracking-[0.2em] uppercase leading-tight">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="hero-scroll absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <div className="w-px h-10 bg-white/30 line-pulse" />
        <div className="w-5 h-5 flex items-center justify-center scroll-bounce">
          <i className="ri-arrow-down-line text-sm text-white/40" />
        </div>
      </div>

      <style>{`
        @keyframes heroZoom {
          from { transform: scale(1.05); }
          to   { transform: scale(1); }
        }
      `}</style>
    </section>
  );
}
